const messages = {
  "Area created successfully": "تم انشاء المنطقة بنجاح",
  "Modified areas successfully": "تم تعديل المناطق  بنجاح",
  "Deleted areas successfully": "تم حذف المناطق بنجاح",
};

export default messages;
